import { toast } from "@hortis/ui/sonner";
import { pipe } from "fp-ts/function";
import { useCallback } from "react";
import { useValidCollectionSite } from "../../../../utils/hooks/collection-site";
import * as OE from "../../../../utils/option-either";
import { useAccessToken } from "../../../../utils/use-access-token";
import { fetchCsv } from "./fetch-csv";

export const useDownloadCsv = ({
  body,
  csvName,
  path,
}: {
  body?: Record<string, unknown>;
  csvName: string;
  path: string;
}) => {
  const collectionSite = useValidCollectionSite();
  const accessToken = pipe(useAccessToken(), OE.noneAndErrorToUndefined);

  return useCallback(async () => {
    const toastId = toast.info("Preparing download", {
      duration: Number.POSITIVE_INFINITY,
    });
    try {
      if (accessToken === undefined) {
        throw new Error("No access token");
      }
      if (collectionSite === undefined) {
        throw new Error("No valid collection site");
      }
      await fetchCsv({
        body: { collectionSiteId: collectionSite.id, ...body },
        accessToken,
        fileName: `${collectionSite.name
          .toLowerCase()
          .replaceAll(" ", "-")}-${csvName}_${new Date().toISOString()}`,
        path,
      });
    } catch {
      toast.error("Unable to retrieve csv for download");
    }
    toast.dismiss(toastId);
  }, [accessToken, collectionSite, body, csvName, path]);
};
